webpackJsonp([78],{

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1274);


/***/ }),

/***/ 1274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(177);

var _datetime2 = _interopRequireDefault(_datetime);

var _enGb = __webpack_require__(789);

var _enGb2 = _interopRequireDefault(_enGb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en-gb', _enGb2.default);

/***/ })

},[1273]);


// WEBPACK FOOTER //
// app/datetime.en-gb-bae561d8d6aea401ccd4.js